var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    width: 14.314,
    height: 16.029,
    viewBox: "0 0 14.314 16.029",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logou_ic",
    transform: "translate(56.613 -2.736) rotate(90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4_",
    d: "M2.537,108.981h7.829a.88.88,0,0,0,0-1.75H2.537s-.729-.032-.729.875S2.537,108.981,2.537,108.981Z",
    transform: "translate(0.929 -58.65)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5_",
    d: "M108.937,42.3a7.152,7.152,0,0,0-5.944,3.169.875.875,0,1,0,1.452.976,5.407,5.407,0,1,1,.007,6.034.875.875,0,0,0-1.45.98A7.157,7.157,0,1,0,108.937,42.3Z",
    transform: "translate(-97.329 0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/Logout.abbdcdd3.svg";
export { ForwardRef as ReactComponent };